import defaultState, { UserServiceReducerInterface } from './defaultState'
import { UserServiceType } from '../../../actions/userService/userServiceTypes'
import { ReduxAction } from '../../reducerType'

const userReducer = (state: UserServiceReducerInterface = defaultState, { type, payload }: ReduxAction): UserServiceReducerInterface => {

  switch (type) {

    case UserServiceType.FETCH_USER_DATA:
      return { ...state,
        status: {
          ...state.status,
          errorResponse: defaultState.status.errorResponse,
          hasError: false,
          isFetching: true
        }
      }
    case UserServiceType.FETCH_USER_DATA_SUCCESS:
      return { ...state,
        BTID: payload.externalIdV2,
        data: payload,
        status: {
          ...state.status,
          errorResponse: defaultState.status.errorResponse,
          hasData: true,
          hasError: false,
          isFetching: false
        }
      }
    case UserServiceType.FETCH_USER_DATA_ERROR:
      return { ...state,
        status: {
          ...state.status,
          errorResponse: payload,
          hasData: false,
          hasError: true,
          isFetching: false
        }
      }
    case UserServiceType.SUBMIT_LOGIN_FORM:
      return {
        ...state,
        status: {
          ...state.status,
          isSubmitting: true
        }
      }
    case UserServiceType.SUBMIT_LOGIN_FORM_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          isSubmitting: false,
          isLoggedin: true
        }
      }
    case UserServiceType.SUBMIT_LOGIN_FORM_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          errorResponse: payload,
          isSubmitting: false,
          hasError: true
        }
      }
    default:
      return state

  }

}

export default userReducer
